import React from 'react';

import { Grow, IconButton, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import emberIcon from 'pages/Students/Assignments/Overview/components/EmberFeedback/assets/ember.png';
import { EMBER_STATUSES } from 'utils/constants';
import { capitalize } from 'utils/index';

const useStyles = makeStyles((theme) => ({
  popup: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(1),
    width: 270,
    borderRadius: 16,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    backgroundColor: '#fff',
    padding: theme.spacing(2),
    zIndex: 1500
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  title: {
    fontWeight: 600,
    color: '#D72638',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  image: {
    maxWidth: 24
  },
  message: {
    padding: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: '#f5f7ff',
    border: '1px solid #eee'
  }
}));

const EmberFeedback = ({ emberDetails, active, open, onClose }) => {
  const classes = useStyles();

  const status = emberDetails?.status;
  const hasNudge = !!emberDetails?.ember_nudge;

  let message = '';
  switch (status) {
    case EMBER_STATUSES.IN_PROGRESS:
      message = 'Ember Tip is being prepared... Please try again later.';
      break;
    case EMBER_STATUSES.NOT_AVAILABLE:
      message = 'No feedback is available for this submission yet.';
      break;
    case EMBER_STATUSES.NOT_STARTED:
      message = 'Please upload all of the requested pages to receive feedback.';
      break;
    default:
      message = hasNudge ? emberDetails.ember_nudge : 'No feedback available.';
      break;
  }

  return (
    <Grow in={open} style={{ transformOrigin: 'bottom right' }}>
      <Paper className={classes.popup} elevation={4}>
        <div className={classes.header}>
          <Typography variant="subtitle1" className={classes.title}>
            <img className={classes.image} src={emberIcon} alt="Ember" />
            {capitalize({ str: active?.status }) || 'Ember'}
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <Typography variant="body2" className={classes.message}>
          {message}
        </Typography>
      </Paper>
    </Grow>
  );
};

export default EmberFeedback;
